import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';

import logo from '../../../../../assets/logo-codeword.jpg';
import { PAGE_NAME } from '../../../../../constants/strings.constant';

// The checkout header. Light since the 2026-10 redesign: the same white card
// with the soft warm border that the site header is (components/Header), with
// the logo cut for a light background and nothing else in it.
export default function Header() {
  return (
    <Box sx={{ flexGrow: 1, marginX: { xs: '1rem', md: '3.75rem' } }}>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar
          sx={(theme) => ({
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '0.75rem',
            boxShadow: `0 2px 12px ${alpha(theme.palette.text.primary, 0.06)}`,
            display: 'flex',
          })}
        >
          {/* The logo sits inside the button the star sat in, which has no
              handler and never had one. Left exactly so: whether the checkout
              logo goes anywhere is a product decision that has not been made,
              and removing the button would change the keyboard's tab order.
              (components/Header/HeaderLogo.test.tsx) */}
          <IconButton
            size="small"
            edge="start"
            color="inherit"
            sx={{ mr: 0, padding: 0, borderRadius: '0.5rem' }}
          >
            <Box
              component="img"
              src={logo}
              alt={PAGE_NAME}
              sx={{
                display: 'block',
                height: { xs: 46, sm: 61 },
                width: 'auto',
              }}
            />
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
